// custom typefaces
// import "./src/css/global.css"
import "typeface-fira-mono"
import "typeface-open-sans"
import "./src/css/global.scss"
import "@fortawesome/fontawesome-svg-core/styles.css";

export function onInitialClientRender () { }
